$(document).ready(function () {
  function convertToNumber(value) {
    return value ? parseFloat(value.replace(/,/g, "")) : 0;
  }
  function change_tot_price() {
    var totalProtection = convertToNumber(
      $(".ctm-quick-checkout-inner").attr("data-total-protection")
    );
    var totalAccessories = convertToNumber(
      $(".ctm-quick-checkout-inner").attr("data-total-accessories")
    );
    var totalWarranty = convertToNumber(
      $(".ctm-quick-checkout-inner").attr("data-total-warranty")
    );

    var total = totalProtection + totalAccessories + totalWarranty;
    $(".fotter-totals span.total-price.total-price-checkout").text(
      total.toFixed(2)
    );
  }

  $(".chekout-header .tab-services").on("click", function () {
    $(".chekout-header ul li").removeClass("active");
    $(".chekout-header .tab-services").addClass("active");
    $("#ctm-quick-checkout-nav .ctm-checkout-steps").hide();
    $(".checkout-step-1.service-container").show();
  });

  $(".chekout-header .tab-accessories").on("click", function () {
    $(".chekout-header ul li").removeClass("active");
    $(".chekout-header .tab-accessories").addClass("active");
    $("#ctm-quick-checkout-nav .ctm-checkout-steps").hide();
    $(".checkout-step-2.accessories-container").show();
  });

  // Event listeners
  $('.get-checkout-products[name="protection"]').on("change", function () {
    let get_product_price = $(this).attr("product-price");
    console.log(get_product_price);

    // Ensure the data attribute is set even if the value is empty or missing
    $("div#ctm-quick-checkout-nav .ctm-quick-checkout-inner").attr(
      "data-total-protection",
      get_product_price || "0"
    );
    change_tot_price();
  });

  $('.get-checkout-products[name="warranty"]').on("change", function () {
    let totalPrice = 0;

    $('.get-checkout-products[name="warranty"]:checked').each(function () {
      let productPrice = parseFloat(
        $(this).attr("product-price").replace(/,/g, "")
      );
      if (!isNaN(productPrice)) {
        totalPrice += productPrice;
      }
    });

    // Use .toFixed(2) to ensure two decimal places, preserving zeros
    $("div#ctm-quick-checkout-nav .ctm-quick-checkout-inner").attr(
      "data-total-warranty",
      totalPrice.toFixed(2)
    );

    console.log("Total Warranty Price: " + totalPrice.toFixed(2));
    change_tot_price();
  });

  $('.get-checkout-products[name="accessories"]').on("change", function () {
    let totalPrice_sec = 0;

    $('.get-checkout-products[name="accessories"]:checked').each(function () {
      let productPrice = parseFloat(
        $(this).attr("product-price").replace(/,/g, "")
      );
      if (!isNaN(productPrice)) {
        totalPrice_sec += productPrice;
      }
    });
    $("div#ctm-quick-checkout-nav .ctm-quick-checkout-inner").attr(
      "data-total-accessories",
      totalPrice_sec.toFixed(2)
    );

    console.log("Total Warranty Price: " + totalPrice_sec.toFixed(2));
    change_tot_price();
  });

  $("input.get-checkout-products:checked").each(function () {
    var value = $(this).val();
    // console.log(value); // Or handle the value as needed
  });

            async function getCityCoordinates(city) {
                const response = await fetch(`https://nominatim.openstreetmap.org/search?city=${city}&format=json`);
                const data = await response.json();
                if (data.length > 0) {
                    const { lat, lon } = data[0];
                    return { lat, lon };
                } else {
                    throw new Error('City not found');
                }
            }

          function convertToDMS(coordinate, isLongitude) {
              const direction = coordinate >= 0
                  ? (isLongitude ? 'E' : 'N')
                  : (isLongitude ? 'W' : 'S');
          
              const absCoordinate = Math.abs(coordinate);
              const degrees = Math.floor(absCoordinate);
              const minutesDecimal = (absCoordinate - degrees) * 60;
              const minutes = Math.floor(minutesDecimal);
              const seconds = ((minutesDecimal - minutes) * 60).toFixed(4);
          
              return `${degrees}° ${minutes}' ${seconds}'' ${direction}`;
          }
          
          document.getElementById('town_city').addEventListener('focusout', async function () {
              const city = document.getElementById('town_city').value;
              try {
                  const { lat, lon } = await getCityCoordinates(city);
          
                  const latDMS = convertToDMS(lat, false);
                  const lonDMS = convertToDMS(lon, true);
          
                  const coordinatesDisplay = document.getElementById('coordinates-final-result');
                  coordinatesDisplay.innerHTML =`<p class="vord-inner">${latDMS}</p><p class="vord-inner">${lonDMS}</p>`;
                  coordinatesDisplay.setAttribute('gps_coord', `${latDMS},${lonDMS}`);
                  console.log(`Latitude: ${latDMS}, Longitude: ${lonDMS}`);
              } catch (error) {
                   const ctm_coordinatesDisplay = document.getElementById('coordinates-final-result');
                  ctm_coordinatesDisplay.innerHTML = 'Please enter Coorect city';
                  // alert(error.message);
              }
          });




          /***************Quick-checkout-addtocart-start********************/
                 function getVariantValue() {
                        const urlObj = new URL(window.location.href);
                        const params = new URLSearchParams(urlObj.search);
                        const variantValue = params.get('variant');
                        if (variantValue && variantValue.includes('/')) {
                            return variantValue.split('/')[0];
                        }
                        return variantValue; 
                    }



                
                
                $('span.added-goto-checkout.button').on('click', function() {
                    let get_pro_title = $('product-info .p-title h1').text();
                    var items = [];
                    const secondProductID = getVariantValue();
                    $('input.get-checkout-products:checked').each(function() {
                        var item = {};
                        var product_id = $(this).val();
                        item['id'] = product_id;
                        item['quantity'] = 1;
                        item['properties'] = {
                              'Specifications for': get_pro_title+'-'+secondProductID,
                              'Specifications': 'true'
                          };
                        items.push(item);
                    });
                
                    var sec_item = {};
                
                    var get_description = $('.chekout-body [name="description"]').val();
                    console.log(get_description);
                
                    var get_town_city = $('.chekout-body input#town_city').val();
                    console.log(get_town_city);  
                
                     var get_gps_coord = $('span#coordinates-final-result').attr("gps_coord");
                    console.log(get_gps_coord);
                    
                    if (secondProductID) {
                        sec_item['id'] = secondProductID;
                        sec_item['quantity'] = 1;
                        sec_item['properties'] = {
                            "family name" : get_description,
                            "Town/city" : get_town_city,
                            "GPS Coordinates" : get_gps_coord,
                            "service" : "true"
                        }; 
                        items.push(sec_item);
                    }
                
                    console.log(items);
                
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify({ items: items }), 
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(data) {
                            window.location.href = "/cart";
                        },
                        error: function(jqXHR, exception) {
                            console.log('Error in adding to cart:', exception);
                        },
                    });
                });
          /***************Quick-checkout-addtocart-end********************/
  
              /*******edite-product-start*******/
              var cmt_currentUrl = window.location.href;
                if (cmt_currentUrl.includes('cart-index')) {
                    $('.goto-next-step .edite-goto-checkout').show();
                    $('.goto-next-step .added-goto-checkout').hide();
                  $('.ns-qucik-view-wrp .ns-qucik-view_submit.button').click();
                } else {
                     $('.goto-next-step .edite-goto-checkout').hide();
                    $('.goto-next-step .added-goto-checkout').show();
                }
            
              $('.goto-next-step .edite-goto-checkout').on('click', function() {
                  var url = window.location.href;
                  var match = url.match(/cart-index=(\d+)/);
                  var cartIndex = match ? match[1] : null;
                  
                  var qunt_pp = 1;

                  var get_description = $('.chekout-body [name="description"]').val();
                    console.log(get_description);
                
                  var get_town_city = $('.chekout-body input#town_city').val();
                    console.log(get_town_city);  
              
                  var get_gps_coord = $('span#coordinates-final-result').attr("gps_coord");
                    console.log(get_gps_coord);
              
                  console.log(cartIndex);

                    let get_pro_title = $('product-info .p-title h1').text();
                        var cvt_items = [];
                        const cdt_secondProductID = getVariantValue();
                        $('input.get-checkout-products:checked').each(function() {
                        var cdt_item = {};
                        var cdt_product_id = $(this).val();
                        cdt_item['id'] = cdt_product_id;
                        cdt_item['quantity'] = 1;
                        cdt_item['properties'] = {
                              'Specifications for': get_pro_title+'-'+cdt_secondProductID,
                              'Specifications': 'true'
                          };
                        cvt_items.push(cdt_item);
                    });

                console.log(cvt_items);
              
                  $.ajax({
                      type: 'POST',
                      url: '/cart/change.js',
                      data: $.param({
                          line: cartIndex,
                          properties: {
                            "family name" : get_description,
                            "Town/city" : get_town_city,
                            "GPS Coordinates" : get_gps_coord,
                            "service" : "true"
                          }
                      }),
                      dataType: 'json',
                      success: function(cart) {
                          // console.log('Quantity and properties updated successfully!');
                          // window.location.href = "/cart";
                            $.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                data: JSON.stringify({ items: cvt_items }), 
                                dataType: 'json',
                                contentType: 'application/json',
                                success: function(data) {
                                    window.location.href = "/cart";
                                },
                                error: function(jqXHR, exception) {
                                    console.log('Error in adding to cart:', exception);
                                },
                            });
                      },
                      error: function() {
                          alert('There was an error updating the quantity or properties.');
                      }
                  });
              });

              /*******edite-product-end*******/
  

});




/*edit detials custom redirecting*/

document.addEventListener('DOMContentLoaded', function() {
  function openCartSidebar() {
    const sidebar = document.getElementById('ctm-quick-checkout-nav');
    if (sidebar) {
      sidebar.classList.add('active');
      
      // Add event listener for clicks outside the sidebar
      document.addEventListener('click', closeSidebarOnClickOutside);
    } else {
      console.error('Sidebar element not found');
    }
  }

  function closeCartSidebar() {
    const sidebar = document.getElementById('ctm-quick-checkout-nav');
    if (sidebar) {
      sidebar.classList.remove('active');
      
      // Remove the event listener after closing the sidebar
      document.removeEventListener('click', closeSidebarOnClickOutside);
    } else {
      console.error('Sidebar element not found');
    }
  }

  function closeSidebarOnClickOutside(event) {
    const sidebar = document.getElementById('ctm-quick-checkout-nav');
    if (sidebar && !sidebar.contains(event.target) && !event.target.closest('#EditDetailsLink')) {
      closeCartSidebar();
    }
  }

  // Add event listener for Edit Details Link
  const editDetailsLink = document.getElementById('EditDetailsLink');
  if (editDetailsLink) {
    editDetailsLink.addEventListener('click', function(event) {
      event.preventDefault();
      openCartSidebar();
    });
  }
});
